module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/diagnostic-test/diagnostic-test.component.css
// module id = ./src/app/Pages/tasks/diagnostic-test/diagnostic-test.component.css
// module chunks = main